const Unauthorise = () => {
  return (
    <div className='flex h-full w-full items-center justify-center'>
      <div className='text-center'>
        <h1 className='text-2xl font-bold'>You are not authorised to access this page</h1>
        <p className='text-sm text-gray-500'>Please contact your administrator to get access</p>
      </div>
    </div>
  )
}

export default Unauthorise
